import {
  handleAddSpecificLocationsBySwitch,
  handleMachineSelectBySwitch,
  handleSpecificLocationSelectBySwitch,
} from '../../../components/store/slices/masterControlBySwitchSelectSlice';
import {
  handleAddSpecificLocationsByLocation,
  handleMachineSelectByLocation,
  handleSpecificLocationSelectByLocation,
} from '../../../components/store/slices/masterControlSelectByLocationSlice';

export const selectSpecificLocationDispatchHandler = (
  dispatch,
  scope,
  name,
  specificLocationList,
  machineList,
  newSpecificLocations,
) => {
  if (scope === 'switch') {
    dispatch(
      handleSpecificLocationSelectBySwitch({
        controller: name,
        arr: specificLocationList,
      }),
    );
    dispatch(
      handleMachineSelectBySwitch({ controller: name, arr: machineList }),
    );
    dispatch(
      handleAddSpecificLocationsBySwitch({
        controller: name,
        arr: newSpecificLocations,
      }),
    );
  } else {
    dispatch(
      handleSpecificLocationSelectByLocation({
        controller: name,
        arr: specificLocationList,
      }),
    );
    dispatch(
      handleMachineSelectByLocation({
        controller: name,
        arr: machineList,
      }),
    );
    dispatch(
      handleAddSpecificLocationsByLocation({
        controller: name,
        arr: newSpecificLocations,
      }),
    );
  }
};
